import en from "@/translations/en.json";

export default {
    en
};